import { SysbizConfig } from "src/app/core/interfaces/sysbiz-config";
import { Partner } from "./partner/_default";

export const Sysbiz: SysbizConfig = {  
  domain: Partner.apiUrl,
  pathPrefix: Partner.pathPrefix != null ? Partner.pathPrefix : 'api'
}